import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { pdfjs } from "react-pdf";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Fab } from "@mui/material";
import {
  Home,
  Research,
  Contact,
  BeeProject,
  LichenProject,
  Education,
  Beauty,
  Essays,
} from "./pages";
import { lightTheme, darkTheme } from "./theme";
import { useThemeToggler } from "./hooks/theme";
import CriAppBar from "./components/CriAppBar";
import CriFooter from "./components/CriFooter";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

function App() {
  const [themeMode, themeToggler] = useThemeToggler();

  return (
    <ThemeProvider theme={themeMode === "light" ? lightTheme : darkTheme}>
      <CssBaseline />
      <BrowserRouter>
        <CriAppBar themeMode={themeMode} themeToggler={themeToggler} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/bees" element={<BeeProject />} />
          <Route path="/research/lichen" element={<LichenProject />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/education" element={<Education />} />
          <Route path="/beauty" element={<Beauty />} />
          <Route path="/essays" element={<Essays />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <CriFooter />
    </ThemeProvider>
  );
}

export default App;
